import styled from 'styled-components';
import { Icon } from '@studio/legacy-components';

export const FlagWrapper = styled.span`
  font-weight: var(--normal);
  color: ${({ $installed }) =>
    $installed ? 'var(--pleather)' : 'var(--dirty-water)'};

  ${Icon} {
    margin-left: 8px;
    color: ${({ $installed }) =>
      $installed ? 'var(--cutecumber)' : 'var(--sharkbait-ooh-la-la)'};
  }
`;

export const FlagTitleText = styled.div`
  font-weight: var(--bold);
`;
